<!--
    BD Pause Dialog — Wave 3
    Startet eine Mahn-Pause (mit Grund-Auswahl) oder beendet eine aktive Pause.
    @ticket TM-1000001786
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Header -->
        <div class="flex align-items-center gap-2">
            <i class="fa-light fa-pause text-primary"></i>
            <span class="font-semibold text-lg">Mahn-Pause</span>
        </div>

        <!-- Error -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Success -->
        @if (success === 'PAUSED') {
            <p-message severity="success"
                       text="Pause wurde gestartet."
                       styleClass="w-full"></p-message>
        }
        @if (success === 'RESUMED') {
            <p-message severity="success"
                       text="Pause wurde beendet — Mahnzyklus läuft weiter."
                       styleClass="w-full"></p-message>
        }

        <!-- Resume section (only if active pause exists) -->
        @if (hasActivePause) {
            <div class="surface-card border-round p-3 bd-active-pause">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="fa-solid fa-circle-pause text-orange-500"></i>
                    <span class="font-semibold">Aktive Pause</span>
                </div>
                <div class="text-sm text-600 flex flex-column gap-1">
                    @if (activePause?.reason) {
                        <div><span class="font-medium">Grund:</span> {{ activePause?.reason }}</div>
                    }
                    @if (activePause?.pauseUntil) {
                        <div>
                            <span class="font-medium">Pause bis:</span>
                            {{ activePause?.pauseUntil | date:'dd.MM.yyyy' }}
                        </div>
                    }
                    @if (activePause?.startedAt) {
                        <div>
                            <span class="font-medium">Gestartet am:</span>
                            {{ activePause?.startedAt | date:'dd.MM.yyyy HH:mm' }}
                        </div>
                    }
                    @if (activePause?.comment) {
                        <div><span class="font-medium">Kommentar:</span> {{ activePause?.comment }}</div>
                    }
                </div>
                <div class="flex justify-content-end mt-3">
                    <p-button label="Pause beenden"
                              icon="fa-light fa-play"
                              severity="secondary"
                              [loading]="submitting"
                              (onClick)="endPause()">
                    </p-button>
                </div>
            </div>
        }

        <!-- Start pause form -->
        @if (!hasActivePause) {
            <div class="surface-card border-round p-3 flex flex-column gap-3">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="block text-sm font-medium mb-1">
                            Pausen-Grund <span class="text-red-500">*</span>
                        </label>
                        <!-- TM-1000001958: Gründe aus der DunningType-Pause-Konfiguration -->
                        <p-select [options]="reasonOptions"
                                  optionLabel="name"
                                  optionValue="id"
                                  [(ngModel)]="selectedReasonId"
                                  (ngModelChange)="reasonInvalid = false"
                                  placeholder="Bitte wählen…"
                                  appendTo="body"
                                  styleClass="w-full"
                                  [ngClass]="{'ng-invalid ng-dirty': reasonInvalid}">
                        </p-select>
                        @if (reasonInvalid) {
                            <small class="text-red-500">Bitte einen Pausen-Grund auswählen.</small>
                        } @else if (!configLoading && reasonOptions.length === 0) {
                            <small class="text-500">
                                Für diesen Mahnungstyp sind keine Pause-Gründe konfiguriert.
                            </small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="block text-sm font-medium mb-1">
                            Pause bis
                            @if (pauseUntilRequired) {
                                <span class="text-red-500">*</span>
                            }
                            <!-- TM-1000001958: Hinweis auf das konfigurierte Maximum -->
                            <span class="text-500 text-xs ml-1">
                                @if (maxPauseDays != null) {
                                    (max. {{ maxPauseDays }} Tage)
                                } @else {
                                    (ohne Angabe: unbefristet)
                                }
                            </span>
                        </label>
                        <!-- C21: Datepicker mit Tastatureingabe TT.MM.JJJJ -->
                        <!-- TM-1000001958: maxDate = heute + maxPauseDays (nur bei gesetztem Maximum) -->
                        <p-datePicker [(ngModel)]="pauseUntil"
                                      dateFormat="dd.mm.yy"
                                      [showIcon]="true"
                                      [showOnFocus]="false"
                                      [maxDate]="maxPauseDate"
                                      placeholder="TT.MM.JJJJ"
                                      appendTo="body"
                                      styleClass="w-full">
                        </p-datePicker>
                    </div>
                </div>

                <div>
                    <label class="block text-sm font-medium mb-1">Kommentar</label>
                    <textarea pInputTextarea
                              [(ngModel)]="comment"
                              rows="3"
                              placeholder="Optionaler Kommentar zur Pause…"
                              class="w-full"></textarea>
                </div>

                <!-- C22: Optionale Checkbox "Bestätigungsschreiben erzeugen" -->
                <div class="flex align-items-center gap-2">
                    <p-checkbox [(ngModel)]="generateConfirmationLetter"
                                [binary]="true"
                                inputId="bd-pause-confirmation-letter">
                    </p-checkbox>
                    <label for="bd-pause-confirmation-letter" class="text-sm">
                        Bestätigungsschreiben erzeugen
                    </label>
                </div>

                <div class="flex justify-content-end">
                    <p-button label="Pause starten"
                              icon="fa-light fa-pause"
                              [loading]="submitting"
                              [disabled]="selectedReasonId == null"
                              (onClick)="startPause()">
                    </p-button>
                </div>
            </div>
        }
    </div>
}
